(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('AppraisalFirmController', AppraisalFirmController);

    AppraisalFirmController.$inject = ['$scope', '$state', 'AppraisalFirm', 'AppraisalFirmSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'Principal', '$mdDialog', 'Lender'];

    function AppraisalFirmController ($scope, $state, AppraisalFirm, AppraisalFirmSearch, ParseLinks, AlertService, pagingParams, paginationConstants, Principal, $mdDialog, Lender) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.admin = false;
        vm.openAddLenderDialog = openAddLenderDialog;
        vm.openRemoveLenderDialog = openRemoveLenderDialog;

        Principal.matchAnyAuthority(/^ROLE_ADMIN/).then(function(result) {
           vm.admin = true;
        });

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                AppraisalFirmSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                AppraisalFirm.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.appraisalFirms = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function openAddLenderDialog (firm, ev) {
            openLenderDialog(firm, ev, 'add');
        }

        function openRemoveLenderDialog (firm, ev) {
            openLenderDialog(firm, ev, 'remove');
        }

        function openLenderDialog (firm, ev, mode) {
            $mdDialog.show({
                templateUrl: 'app/entities/appraisal-firm/firm-lender-bulk-dialog.html',
                controller: 'FirmLenderBulkDialogController',
                controllerAs: 'vm',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    firm: firm,
                    mode: mode,
                    lenders: Lender.querySimple(),
                    AppraisalFirm: AppraisalFirm,
                    AlertService: AlertService
                }
            });
        }
    }
})();
